import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import store from './app/store';
import {Provider} from 'react-redux';
import reportWebVitals from './reportWebVitals';
import './i18n';

// Leaflet styles
import 'leaflet/dist/leaflet.css';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Service Worker Registration with periodic update checks
import { registerSW } from 'virtual:pwa-register';

// Track if this is the initial load
let isInitialRegistration = !navigator.serviceWorker?.controller;

const updateSW = registerSW({
    immediate: true,
    onRegisteredSW(swUrl, registration) {
        console.log('Service Worker registered:', swUrl);

        // Periodic update check every 90 seconds
        const checkForUpdates = () => {
            if (document.visibilityState === 'visible' && registration) {
                console.log('Checking for service worker updates...');
                registration.update();
            }
            setTimeout(checkForUpdates, 90000); // 90 seconds
        };

        // Start periodic checks
        checkForUpdates();

        // Also check when page becomes visible
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && registration) {
                registration.update();
            }
        });
    },
    onRegisterError(error) {
        console.error('Service Worker registration failed:', error);
    }
});

// Listen for controller change to detect when new SW takes over
if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Skip the first time (initial registration)
        if (isInitialRegistration) {
            isInitialRegistration = false;
            console.log('Service Worker initial activation');
        } else {
            // New service worker has taken control!
            console.log('New service worker activated - reloading page');
            // Show a brief notification before reload
            const message = 'Uusi versio saatavilla! Päivitetään...';
            // Create a simple toast notification
            const toast = document.createElement('div');
            toast.textContent = message;
            toast.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#2196F3;color:white;padding:12px 24px;border-radius:4px;z-index:10000;font-family:system-ui;';
            document.body.appendChild(toast);

            // Reload after a brief delay to show the message
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    });
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(/*console.log*/);
